import { FC } from 'react';
import { CustomTooltip } from '@dynamika-shared/ui/Tooltip/CustomTooltip';
import { Avatar } from '@components/Avatar/Avatar';
import { twMerge } from '@utils/twMerge';

type TeamMemberInfoProps = {
  fullName?: string;
  email?: string;
  enabled?: boolean;
  className?: string;
  classNameText?: string;
};
export const UserInfo: FC<TeamMemberInfoProps> = ({
  fullName,
  email,
  enabled,
  className,
  classNameText,
}) => {
  return (
    <div className={twMerge('flex items-center gap-[1.2rem]', className)}>
      <Avatar
        className={enabled ? '' : 'text-dimGray'}
        userName={fullName ?? ''}
      />
      <div
        className={twMerge('text flex max-w-[20rem] flex-col', classNameText)}
      >
        {fullName && (
          <CustomTooltip
            label={fullName}
            className={twMerge(enabled ? 'text-black' : 'text-spanishGray')}
          />
        )}
        {email && (
          <CustomTooltip
            label={email}
            className={twMerge(
              'text-1216 mt-[2px]',
              enabled ? 'text-dimGray' : 'text-spanishGray'
            )}
          />
        )}
      </div>
    </div>
  );
};
